module.exports = __webpack_public_path__ + "img/team-03.40ac4af6.jpg";